import React from 'react';
import useDealAccountingPayments from '../hooks/useDealAccountingPayments';
import AccountingAttachmentsPanel from '../../../accounting/components/shared/AccountingAttachmentsPanel';
import { useLinkedEntityCards } from '../../../../shared/components/linked-entities/LinkedEntityCardHost';
import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import IconAction from '../../../../shared/components/IconAction';

export default function DealAccountingSection({ deal, dealType }) {
  const paymentState = useDealAccountingPayments(deal, dealType);
  return <DealAccountingContent deal={deal} dealType={dealType} {...paymentState} />;
}

export function DealAccountingContent({ deal, dealType, payments = [], loading = false, error = '', synchronize }) {
  const { openEntityCard } = useLinkedEntityCards();
  const completed = dealType === 'completato';
  const proposal = dealType === 'proposta';

  return (
    <section className="accounting-detail__section">
      {!proposal ? <>
        <h3>Incassi collegati</h3>
        {loading ? <p role="status">Caricamento incassi…</p> : null}
        {error ? <p role="alert" className="wt-inline-error">{error}</p> : null}
        {payments.map((payment) => (
          <EntityLinkButton key={payment.id}
            onClick={() => openEntityCard({ entityType: 'payment', entityId: payment.id })}>
            <strong>{payment.installment ? `Rata ${payment.installment}` : 'Incasso'} · {Number(payment.amount).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}</strong>
            <span>{payment.status === 'previsto' ? 'Da incassare' : payment.status}</span>
          </EntityLinkButton>
        ))}
        {!loading && !payments.length ? <p>Nessun incasso collegato.</p> : null}
        {(!payments.length || error) ? <IconAction label="Sincronizza incassi" iconKey="actions.reset" disabled={loading} onClick={synchronize} /> : null}
      </> : null}
      <h3>Allegati</h3>
      <AccountingAttachmentsPanel entity={deal}
        linkedEntityType={proposal ? 'PROPOSAL' : completed ? 'COMPLETED_DEAL' : 'IN_PROGRESS_DEAL'}
        entityLabel={deal.name || 'affare'} clientName={deal.client || ''} />
    </section>
  );
}
